import { getSize } from "./index";
export const renderVideo = (option, play, pause) => {
    const dom = document.createElement("video");
    const audio = document.createElement("audio");
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    dom.crossOrigin = "anonymous";
    audio.crossOrigin = "anonymous";
    dom.src = option.adLink;
    audio.src = option.adLink;
    dom.muted = true;
    dom.load();
    audio.load();
    const { width, height } = getSize();
    let timer;
    dom.onerror = (error) => {
        console.log(error);
        dom.currentTime = 0;
        audio.currentTime = 0;
        audio.pause();
        pause();
        clearInterval(timer);
        throw error;
    };
    let videoFlag = false;
    let audioFlag = false;
    audio.onerror = (error) => {
        audioFlag = false;
        throw error;
    };
    const plays = () => {
        audioFlag = true;
        play();
        audio.play();
    };
    const pauses = () => {
        audioFlag = false;
        pause();
        audio.pause();
    };
    const uptime = () => {
        timer = setInterval(() => {
            if (videoFlag) {
                dom.currentTime = dom.currentTime + 0.033;
                if (dom.currentTime >= dom.duration) {
                    dom.currentTime = 0;
                    audio.currentTime = 0;
                    audio.play();
                }
            }
        }, 33);
    };
    const adPlay = () => {
        if (videoFlag && audioFlag) {
            uptime();
        }
    };
    audio.addEventListener("loadedmetadata", async () => {
        adPlay();
    });
    audio.addEventListener("canplay", () => {
        plays();
    });
    audio.addEventListener("play", () => {
        plays();
    });
    audio.addEventListener("pause", () => {
        pauses();
    });
    audio.addEventListener("loadeddata", () => {
        pauses();
    });
    dom.addEventListener("loadedmetadata", async () => {
        canvas.width = width;
        canvas.height = height;
        videoFlag = true;
        adPlay();
    }, { passive: false });
    dom.addEventListener("canplay", () => {
        videoFlag = true;
        plays();
    });
    dom.addEventListener("play", () => {
        videoFlag = true;
        plays();
    });
    dom.addEventListener("pause", () => {
        videoFlag = false;
        pauses();
    });
    dom.addEventListener("loadeddata", () => {
        videoFlag = false;
        pauses();
    });
    dom.addEventListener("seeked", () => {
        context.drawImage(dom, dom.videoWidth < width ? (width - dom.videoWidth) / 2 : 0, dom.videoHeight < height ? (height - dom.videoHeight) / 2 : 0, dom.videoWidth < width ? dom.videoWidth : width, dom.videoHeight < height ? dom.videoHeight : height);
    }, { passive: false });
    const observer = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) {
            clearInterval(timer);
            setTimeout(() => {
                audio.currentTime = 0;
                dom.currentTime = 0;
                pauses();
            }, 1);
        }
    });
    observer.observe(canvas);
    return canvas;
};
//# sourceMappingURL=video.js.map